import { useEffect, useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { Job } from "@/models/Job.model";
import { useJobListingStore } from "@/store/jobs/jobs.store";

export const useSingleJob = (slug: string) => {
  const { jobListings, setJobListings } = useJobListingStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const querySnapshot = await collectionRef.Jobs.where(
        "slug",
        "==",
        slug
      ).get();
      const data: Job[] = [];
      querySnapshot.forEach((doc) => {
        const jobData = doc.data() as Omit<Job, "id">;
        const schedule = {
          ...jobData,
          id: doc.id,
        } as Job;
        data.push(schedule);
      });
      setJobListings(data);
      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!jobListings || !jobListings.some((listing) => listing.slug === slug)) {
      fetchData();
    }
  }, [jobListings, slug]);

  return {
    data: jobListings?.find((listing) => listing.slug === slug) || null,
    loading,
    error,
  };
};
